<script lang="ts">
  import { computed, type HTMLAttributes } from 'vue'
  import { Skeleton } from '@gat-ship/vue-components/skeleton'

  export type DataListAs = 'div' | 'ul' | 'ol'

  export interface DataListProps {
    as?: DataListAs
    divider?: boolean
    /** If true, the component will show a loading state */
    loading?: boolean
    /** If true, the component will show an empty state. If an object is provided, it will show the empty state with the provided icon and text */
    empty?: boolean | (EmptyStateDashedProps & { isEmpty: boolean })
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  import EmptyStateDashed, {
    type EmptyStateDashedProps
  } from '../layouts/states/EmptyStateDashed.vue'

  const props = withDefaults(defineProps<DataListProps>(), {
    as: 'div',
    divider: true,
    loading: false,
    empty: false
  })

  // ai suggestions: add density, spacing, empty/loading props - keep those for later or in presets
</script>

<template>
  <component
    :is="props.as"
    :class="[
      cn('flex flex-col', props.class),
      { 'divide-border divide-y': props.divider },
      { 'divide-accent divide-y': props.loading }
    ]"
  >
    <slot v-if="props.loading" name="loading">
      <skeleton class="bg-accent h-24 w-full" />
    </slot>
    <slot
      v-else-if="
        (typeof props.empty === 'object' && props.empty.isEmpty) ||
        (typeof props.empty === 'boolean' && props.empty)
      "
      name="empty"
    >
      <empty-state-dashed icon="Coffee" text="Resource not found" />
    </slot>
    <slot v-else />
  </component>
</template>
